module.exports = __webpack_public_path__ + "img/service.0b82db3c.png";